import GeometryCollection from 'ol/geom/GeometryCollection';
import { geoJSONToFeature } from './geoJSONFeature';
export const geoJSONFeatureToGeometryCollection = (features) => {
    const geometries = [];
    features.forEach((feature) => {
        const geometry = geoJSONToFeature(feature).getGeometry();
        geometry && geometries.push(geometry);
    });
    const geometryCollection = new GeometryCollection(geometries);
    return geometryCollection;
};
//# sourceMappingURL=geometry.js.map